import { IDevicePosition } from "./devices.interface";

const MarkerIcon = (marker: google.maps.Marker, rotation?: number, device?: IDevicePosition, activeMarker?: any) => {
    let markerColor = "";
    let markerStrokeColor = "";
    if (activeMarker?.label === device?.label) {
        markerColor = "#7FBECC";
        markerStrokeColor = "#02382D";
    } else {
        markerColor = device?.status === 3 ? "#DC6803" : device?.status === 1 || device?.status === 2 ? "#73C322" : "#73C322";
        markerStrokeColor = device?.status === 3 ? "#B42318" : device?.status === 1 || device?.status === 2 ? "#2F6C12" : "#2F6C12";
    }

    const icon = marker.setIcon({
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: markerColor,
        fillOpacity: 1,
        scale: 7,
        strokeColor: markerStrokeColor,
        strokeWeight: 1,
        rotation: rotation
    });

    return icon;
};
export default MarkerIcon;
